import { useQuery } from '@tanstack/react-query';
import { profileService } from '@/services/profile/profileService';
import { queryKeys } from '@/lib/queryKeys';
import { STALE_TIME_AUTH } from '@/lib/queryCacheConfig';

/**
 * Fetches user profile via TanStack Query.
 */
export const useProfile = (userId: string | undefined) => {
  return useQuery({
    queryKey: queryKeys.profile(userId ?? ''),
    queryFn: () => profileService.getProfile(userId!),
    enabled: !!userId,
    staleTime: STALE_TIME_AUTH.profile,
  });
};
